import { useEffect } from 'react';
import { SettingWrapper } from './style';
import { useDispatch, useSelector } from 'react-redux';

// Libs
import Translation from 'libs/Translation';
import ModalManager from 'libs/ModalManager';

// Component
import Button from 'components/common/Button';
import Link from 'components/common/Link';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import PersonIcon from '@mui/icons-material/Person';
import EventSeatIcon from '@mui/icons-material/EventSeat';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// Redux
import { setUserAction, setAuthenticationAction } from 'redux/user/actions';


const Setting = ({ webConfig }) => {
    const { user } = useSelector(state => state.user);
    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(setUserAction({}));
		dispatch(setAuthenticationAction({}));
        ModalManager.hide();
    }
    
    const items = [
        {id: 0, label: Translation.t('label.account-info'), link: '/profile', params: {lang: webConfig.lang}, icon: <PersonIcon /> },
        {id: 1, label: Translation.t('title.user-appointments'), link: '/profile/appointments', params: {lang: webConfig.lang}, icon: <EventSeatIcon /> }
    ]

    return (
        <SettingWrapper>
            <div className='items'>
                {items.map(i => (
                    <Link
                        to={i.link}
                        params={webConfig.lang !== 'fa' ? i.params : {}}
                        key={i.id}
                        className="item"
                        onClick={() =>  ModalManager.hide()}
                    >
                        <span className='label'>
                            {i.icon}
                            {i.label}
                        </span>
                        
                        {webConfig.dir === 'ltr'
                        ?
                        <ArrowForwardIosIcon className='icon'/>
                        :
                        <ArrowBackIosIcon className='icon'/>
                        }
                    </Link>
                ))}
            </div>
            <Button
                onClick={handleLogout}
                className="logout"
            >
                {Translation.t('label.logout')}
            </Button>
        </SettingWrapper>
    )
}
export default Setting;